import React from 'react';
import checkMarkIcon from '../assets/icons/check-mark.svg';

interface FormLabelBoxProps {
  value: string;
  description: string;
  label: string;
  sublabel?: string;
}

const FormLabelBox: React.FC<FormLabelBoxProps> = ({ value, description, label, sublabel }) => {
  if (!value) {
    return null; 
  }
  return (
    <div className="form-label-box">
      {label && sublabel ?
       <><div className="form-label-box__title">{label}</div>
      <div className="form-label-box__subtitle">{sublabel}</div>
      </> : 
      <div className="form-label-box__subtitle">{label}</div>}
      <div className="form-label-box__content">
        <div className="form-label-box__code-container">
          <div className="form-label-box__code">{value}</div>
          <div className="form-label-box__check-icon">
            <img src={checkMarkIcon} alt="Check mark" />
          </div>
        </div>
        <div className="form-label-box__discount-container">
          <div className="form-label-box__discount">{description}</div>
        </div>
      </div>
    </div>
  );
};

export default FormLabelBox;
